import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-navi';
import { Asset, Copyable, Box, themeUtils as tu } from '@zen-common/components-base';
import { assetUtils } from '@zen/common-utils';
import { isZP } from '@zen/common-utils/lib/utils/assetUtils';
import PATHS from '../../paths';

/**
 * Display a pair, links to orderbook
 *
 * @export
 * @param {Object} props
 * @param {string} props.base - the base asset
 * @param {string} props.quote - the quote asset
 * @param {boolean} props.copy - add ability to copy each asset
 * @param {boolean} [props.link=true] - should link to orderbook
 */
export default function Pair({ base, quote, copy = true, link = true, naming }) {
  const isMobile = document.body.clientWidth < tu.breakpoints.xl.replace('px', '');
  const Container = link ? PairLink : PairContainer;
  const baseQuote = isZP(base) ? { base: quote, quote: base } : { base, quote };
  const containerProps = link
    ? { href: `${PATHS.ORDER_BOOK}?base=${baseQuote.base}&quote=${baseQuote.quote}` }
    : {};
  const displayName = (asset) =>
    naming && naming[asset]
      ? isMobile || naming[asset].name.length > 20
        ? naming[asset].shortName
        : naming[asset].name
      : assetUtils.truncateOrNameAsset(asset);
  const content = (
    <Container {...containerProps}>
      <Asset hash={baseQuote.base} displayName={displayName(baseQuote.base)} />
      <Box>/</Box>
      <Asset hash={baseQuote.quote} displayName={displayName(baseQuote.quote)} />
    </Container>
  );
  return copy ? (
    <Copyable value={`${baseQuote.base}/${baseQuote.quote}`}>{content}</Copyable>
  ) : (
    content
  );
}

const PairLink = styled(Link)`
  display: flex;
  cursor: pointer;
  color: ${tu.color('link')};
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none !important;
  }
`;
const PairContainer = styled(Box)`
  display: flex;
`;
